import {Grid, Typography} from "@mui/material";
import Tarjeta_Blog_Home from "./Tarjetas/Tarjeta_Blog_Home";
import diego from "../../Recursos/diego.png";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {Link} from "react-router-dom";
import Lista_Blog from "./Componentes/SubComponentes/Lista_Blog";


const Seccion_Blog = () => {

    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{maxWidth: 1400, px: 3, pt: sCell ? 16 : 16}}>

                <Grid container
                      justifyContent="flex-start"
                      alignItems="center"
                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography variant='h2'>
                        Blog
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 0}}>
                    <Lista_Blog/>
                </Grid>
            </Grid>
        </Grid>
    )

}
export default Seccion_Blog;